const initialvalues = {

    bakFlag: false,
    backFlag1: "fresh",
    formikValues: {},
    payment: "",
    setOwnerDetailsbyRadio: [],
    setfilterOwnerDetailsbyRadio: [],
    setDueDetails: [],
}

function TapFeeReducer(details = initialvalues, action) {
    switch (action.type) {
        case "TAPPAYMENT": return {
            ...details,
            payment: action.payload
        };
        case "TAPSETOWNERDETAILSBYRADIO": return {
            ...details,
            setOwnerDetailsbyRadio: action.payload
        };
        case "TAPSETFILTEROWNERDETAILSBYRADIO": return {
            ...details,
            setfilterOwnerDetailsbyRadio: action.payload
        };
        case "TAPSETDUEDETAILS": return {
            ...details,
            setDueDetails: action.payload
        };
        case "TAPFORMIKVALUES": return {
            ...details,
            formikValues: action.payload
        };
        case "TAPBACKFLAG": return {
            ...details,
            bakFlag: action.payload
        };
        case "TAPBACKFLAG1": return {
            ...details,
            bakFlag1: action.payload
        };
        default: return details;
    }
}

export default TapFeeReducer;